import React from 'react';
import CopyDetailsFieldsButton from './CopyDetailsFieldsButton';
import MassUpdateControlsLayout
  from '../../../../../shared/widgets/MassUpdate/MassUpdateControlsLayout';

export function DetailFieldsMassUpdate() {
  return (
    <MassUpdateControlsLayout>
      <CopyDetailsFieldsButton />
    </MassUpdateControlsLayout>
  );
}
